import { render, staticRenderFns } from "./ClientesStatus.graphic.vue?vue&type=template&id=45c6374d&scoped=true"
import script from "./ClientesStatus.graphic.vue?vue&type=script&lang=js"
export * from "./ClientesStatus.graphic.vue?vue&type=script&lang=js"
import style0 from "./ClientesStatus.graphic.vue?vue&type=style&index=0&id=45c6374d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6374d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
